module.exports = __webpack_public_path__ + "static/media/292145.de9a350b.png";